"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".alert[_ngcontent-%COMP%]{padding:.5rem 1.25rem;margin-bottom:1rem;margin-top:1rem;border:1px solid transparent;border-radius:.4rem;font-weight:500}.alert.msg-error[_ngcontent-%COMP%]{background-color:#e63a20;border:1px solid #e63a20;color:#fff}.alert.msg-success[_ngcontent-%COMP%]{background-color:#54d2df;border:1px solid #54d2df;color:#fff}"];
exports.styles = styles;
